module.exports = __webpack_public_path__ + "img/aplicaciones_moviles.d422a5d5.jpeg";